/* eslint-disable jsdoc/require-file-overview -- When touching please add documentation. */
import axios from 'axios';
import Vue from 'vue';
import { getStoreBuilder } from 'vuex-typex';
import { CommentNotification } from '@/models';
import * as utils from '@/utils';
const storeBuilder = getStoreBuilder();
const moduleBuilder = storeBuilder.module('notification', {
    notifications: {},
    hasUnread: false,
});
// eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
export var NotificationStore;
(function (NotificationStore) {
    // eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
    NotificationStore.commitUpdateNotifications = moduleBuilder.commit(
    // eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
    (state, payload) => {
        payload.notifications.forEach(n => Vue.set(state.notifications, n.id, n));
        state.hasUnread = payload.notifications.some(x => !x.read);
    }, 'commitUpdateNotification');
    // eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
    NotificationStore.commitUpdateHasUnread = moduleBuilder.commit(
    // eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
    (state, payload) => {
        state.hasUnread = payload.hasUnread;
    }, 'commitUpdateHasUnread');
    // eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
    NotificationStore.commitClearNotifications = moduleBuilder.commit(state => {
        state.notifications = {};
        state.hasUnread = false;
    }, 'commitClearNotifications');
    // eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
    NotificationStore.dispatchMarkAllAsRead = moduleBuilder.dispatch(async (_, __) => {
        const response = await axios.patch('/api/v1/notifications/', {
            notifications: NotificationStore.getAllUnreadNotifications().map(r => ({
                id: r.id,
                read: true,
            })),
        });
        const notifications = response.data.notifications.map(n => CommentNotification.fromServerData(n));
        return {
            ...response,
            cgResult: notifications,
            onAfterSuccess: () => {
                NotificationStore.commitUpdateNotifications({ notifications });
            },
        };
    }, 'dispatchMarkAllAsRead');
    // eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
    NotificationStore.dispatchLoadHasUnread = moduleBuilder.dispatch(async (_, __) => {
        //
        const response = await axios.get('/api/v1/notifications/?has_unread');
        NotificationStore.commitUpdateHasUnread({ hasUnread: response.data.has_unread });
    }, 'dispatchLoadHasUnread');
    // eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
    NotificationStore.dispatchLoadNotifications = moduleBuilder.dispatch(async (_, __) => {
        const response = await axios.get('/api/v1/notifications/');
        NotificationStore.commitUpdateNotifications({
            notifications: response.data.notifications.map(n => CommentNotification.fromServerData(n)),
        });
        return response;
    }, 'dispatchLoadNotifications');
    // eslint-disable-next-line
    function _getAllNotifications(state) {
        return Object.values(state.notifications).sort((a, b) => {
            if (a.read && !b.read) {
                return 1;
            }
            else if (!a.read && b.read) {
                return -1;
            }
            else {
                return b.createdAt.valueOf() - a.createdAt.valueOf();
            }
        });
    }
    // eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
    NotificationStore.getAllNotifications = moduleBuilder.read(_getAllNotifications, 'getAllNotifications');
    // eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
    NotificationStore.getAllUnreadNotifications = moduleBuilder.read(state => _getAllNotifications(state).filter(x => !x.read), 'getAllUnreadNotifications');
    // eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
    NotificationStore.getHasUnreadNotifications = moduleBuilder.read(state => state.hasUnread, 'getHasUnreadNotifications');
    utils.signal.AFTER_USER_CHANGED.register(async () => {
        NotificationStore.commitClearNotifications();
    });
})(NotificationStore || (NotificationStore = {}));
